import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './BalancesDocumentsTableHeadRow.scss';

export const COMMISSION_ACCOUNTS_TABLE_HEADER = [
  {
    label: 'documentId'
  },
  {
    label: 'documentName'
  },
  {
    label: 'documentType'
  },
  {
    label: 'createdAt',
    sortBy: 'created_at'
  }
];

const BalancesDocumentsTableHeadRow = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {COMMISSION_ACCOUNTS_TABLE_HEADER.map(
        (head) =>
          head.label && (
            <th key={head.label} className={'balances-documents-table-head'}>
              <div className={'balances-documents-table-head-block'}>
                <span>{i18n.getMessage(`balances.balancesDocuments.table.header.${head.label}`)}</span>
                {head.sortBy && (
                  <ArrowSelect
                    onClick={() => handleOnSortTable(head.sortBy)}
                    className={`balances-documents-sorting-arrow-icon ${sortBy === head.sortBy && direction}`}
                  />
                )}
              </div>
            </th>
          )
      )}
    </tr>
  );
};

BalancesDocumentsTableHeadRow.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};

export default BalancesDocumentsTableHeadRow;
